import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    width: '100%',
    alignItems: 'center',
    paddingBottom: 12
  },
  contactDetails: {
    fontSize: 9,
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    width: '60%',
    backgroundColor: '#e4e4e4',
    paddingHorizontal: 20,
    paddingVertical: 5,
    borderBottomLeftRadius: 100,
    borderBottomRightRadius: 100
  },
  itemContainer: {
    flexDirection: 'row-reverse'
  },
  img: {
    height: 30
  },
  adotelText: {
    marginTop: 8,
    fontSize: 10
  },
  adotelImgContainer: {
    marginTop: 7,
    height: 15,
    marginRight: 3
  },
  adotelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  }
})
export default styles
